import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, FormTextarea, SectionHeader } from '../../form';
import { Field, Input, Label } from '@headlessui/react';

const AlternativeBilling: React.FC<any> = ({ formik }) => {
  const { t } = useTranslation();

  return (
    <SectionHeader
      title={t('prechecks.alternativeBilling')}
      icon={
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z" />
        </svg>
      }
      iconBgColor="bg-orange-100"
      iconTextColor="text-orange-600"
      titleColor="text-orange-600"
    >
      {/* Custom checkbox field for abProduct */}
      <Field>
        <Label className="text-base font-semibold text-slate-700 mb-4 block">
          {t('prechecks.pleaseSelectProduct')}
        </Label>
        <div className="bg-white rounded-lg p-4 border border-slate-200">
          <Field className="flex items-center mb-2">
            <Input
              type="checkbox"
              name="abProduct"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value="sepa"
              className="w-5 h-5 text-blue-600 bg-white border-slate-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out cursor-pointer"
            />
            <Label className="text-base font-medium text-slate-700 ml-3 cursor-pointer">{t('prechecks.sepaTransferPayouts')}</Label>
          </Field>

          <Field className="flex items-center mb-2">
            <Input
              type="checkbox"
              name="abProduct"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value="sofort"
              className="w-5 h-5 text-blue-600 bg-white border-slate-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out cursor-pointer"
            />
            <Label className="text-base font-medium text-slate-700 ml-3 cursor-pointer">{t('prechecks.sofortKlarna')}</Label>
          </Field>
        </div>
        {formik.touched.abProduct && formik.errors.abProduct ? (
          <div className="text-red-700 text-sm mt-2 bg-red-50 border border-red-200 p-2 rounded">{formik.errors.abProduct}</div>
        ) : null}
      </Field>

      <FormField
        id="abProjectedVolume"
        name="abProjectedVolume"
        label={t('prechecks.projectedMonthlyVolume')}
        type="text"
        value={formik.values.abProjectedVolume}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.abProjectedVolume}
        touched={formik.touched.abProjectedVolume}
      />

      <FormField
        id="abProjectedTxCount"
        name="abProjectedTxCount"
        label={t('prechecks.projectedMonthlyNumberOfTransactions')}
        type="text"
        value={formik.values.abProjectedTxCount}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.abProjectedTxCount}
        touched={formik.touched.abProjectedTxCount}
      />

      <FormField
        id="abLowestTxAmount"
        name="abLowestTxAmount"
        label={t('prechecks.lowestTransactionAmount')}
        type="text"
        value={formik.values.abLowestTxAmount}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.abLowestTxAmount}
        touched={formik.touched.abLowestTxAmount}
      />

      <FormField
        id="abHighestTxAmount"
        name="abHighestTxAmount"
        label={t('prechecks.highestTransactionAmount')}
        type="text"
        value={formik.values.abHighestTxAmount}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.abHighestTxAmount}
        touched={formik.touched.abHighestTxAmount}
      />

      <FormField
        id="abAvgTxAmount"
        name="abAvgTxAmount"
        label={t('prechecks.averageTransactionAmount')}
        type="text"
        value={formik.values.abAvgTxAmount}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.abAvgTxAmount}
        touched={formik.touched.abAvgTxAmount}
      />

      <FormTextarea
        id="abTargetMarkets"
        name="abTargetMarkets"
        label={t('prechecks.listAllTargetMarkets')}
        value={formik.values.abTargetMarkets}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.abTargetMarkets}
        touched={formik.touched.abTargetMarkets}
        rows={4}
      />

      <FormField
        id="abSalesTurnover"
        name="abSalesTurnover"
        label={t('prechecks.lastYearsSalesTurnoverInEUR')}
        type="text"
        value={formik.values.abSalesTurnover}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.abSalesTurnover}
        touched={formik.touched.abSalesTurnover}
      />
    </SectionHeader>
  );
};

export default AlternativeBilling;
